(function () {
  const globalKey = "PacificCoastMulticolumnSlider";

  if (window[globalKey]) {
    window[globalKey].refresh(document);
    return;
  }

  const sliderSelector = ".swiper--multicolumn";
  const mobileQuery = window.matchMedia("(max-width: 989px)");

  function getSliders(root) {
    const sliders = [];

    if (root instanceof Element && root.matches(sliderSelector)) {
      sliders.push(root);
    }

    if (root && root.querySelectorAll) {
      root.querySelectorAll(sliderSelector).forEach((slider) => {
        sliders.push(slider);
      });
    }

    return sliders;
  }

  function initializeSlider(slider) {
    if (!mobileQuery.matches) return;
    if (slider.swiper && !slider.swiper.destroyed) return;
    if (typeof window.Swiper !== "function") return;

    const previousButton = slider.querySelector(
      ".multicolumn__button-prev"
    );
    const nextButton = slider.querySelector(
      ".multicolumn__button-next"
    );
    const pagination = slider.querySelector(
      ".multicolumn__pagination"
    );

    const options = {
      loop: false,
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 12,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl: previousButton,
        nextEl: nextButton,
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      a11y: {
        enabled: true,
        containerMessage: "Store services",
        containerRoleDescriptionMessage: "carousel",
        itemRoleDescriptionMessage: "service card",
        prevSlideMessage: "Previous service",
        nextSlideMessage: "Next service",
        slideLabelMessage: "{{index}} of {{slidesLength}}",
        paginationBulletMessage: "Go to service {{index}}",
      },
      breakpoints: {
        750: {
          slidesPerView: 2,
          slidesPerGroup: 1,
          spaceBetween: 16,
        },
      },
    };

    if (pagination) {
      options.pagination = {
        el: pagination,
        clickable: true,
      };
    }

    new window.Swiper(slider, options);
  }

  function destroySlider(slider) {
    if (slider.swiper && !slider.swiper.destroyed) {
      slider.swiper.destroy(true, true);
    }
  }

  function refresh(root) {
    getSliders(root || document).forEach((slider) => {
      if (mobileQuery.matches) {
        initializeSlider(slider);
      } else {
        destroySlider(slider);
      }
    });
  }

  function handleViewportChange() {
    refresh(document);
  }

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener("change", handleViewportChange);
  } else {
    mobileQuery.addListener(handleViewportChange);
  }

  document.addEventListener("shopify:section:load", function (event) {
    refresh(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    getSliders(event.target).forEach(destroySlider);
  });

  window[globalKey] = {
    refresh,
  };

  refresh(document);
})();
